@if (loading) {
  <div class="loader"></div>
}
@if (!loading) {
  <div class="left-modal">
    <div class="close" (click)="close()"></div>
    @if (!loading) {
      <div class="modal-container">
        @if (project.phases_project.length) {
          <h1>{{'Edit phases' | translate}}</h1>
        }
        @if (!project.phases_project.length) {
          <h1>{{'Add phases' | translate}}</h1>
        }
        <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
          <div class="row">
            @for (phase of formData.phases; track phase) {
              <div class="columns"
                [ngClass]="{'L-6 M-6 S-6': phaseHasOnlyWeeks(phase), 'L-12 M-12 S-12': !phaseHasOnlyWeeks(phase)}">
                <h3 class="L-12 M-12 S-12 columns">{{_gS.backTranslate(phase, 'phase')}}</h3>
                @if (!phaseHasOnlyWeeks(phase)) {
                  <div class="L-6 M-6 S-6 columns">
                    <label>{{'Date start' | translate}}</label>
                    <input type="date" name="date_start_{{phase.phase_id}}" [(ngModel)]="phase.date_start" [required]="dateIsRequired(phase)">
                  </div>
                }
                <div class="columns" [ngClass]="{'L-6 M-6 S-6': !phaseHasOnlyWeeks(phase), 'L-12 M-12 S-12': phaseHasOnlyWeeks(phase)}">
                  <label>{{'Weeks' | translate}}</label>
                  <input class="centered" numeric type="text" name="week_{{phase.phase_id}}" [required]="weekIsRequired(phase)" [(ngModel)]="phase.week" placeholder="{{'Insert' | translate}}">
                </div>
              </div>
            }
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Save' | translate}}" [disabled]="form.invalid || !formHasValues()">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}